export default __webpack_public_path__ + "static/media/weeat.d20569a2.png";